<template>
  <v-theme-provider :theme="resolvedTheme" with-background>
    <slot />
  </v-theme-provider>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { useSettingStore } from '@/stores/settings';
  import { storeToRefs } from 'pinia';

  export default defineComponent({
    name: 'ThemeProvider',
    setup() {
      const settingStore = useSettingStore();
      const { resolvedTheme } = storeToRefs(settingStore);
      return { resolvedTheme };
    },
  });
</script>
